import React from 'react';

import styles from './ErrorMessage.module.scss';

interface ErrorMessageProps {
  message: string;
}

// This element will be displayed when MRE is not supported or an error occurs
export const ErrorMessage = ({ message }: ErrorMessageProps) => {
  return (
    <div data-testid="error-message" className={styles.errorMessage}>
      {message}
    </div>
  );
};
